// @flow

import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router-dom';
import RippleButton from '../../components/RippleButton';
import type { MapViewer } from '../../types/VisioglobeType';
import { isMobile } from '../../const';

type Props = {
  mapviewer: MapViewer,
  className?: string,
}

type State = {
  showFloors: boolean,
}

class VisioGlobeUI extends React.PureComponent<Props, State> {
  static defaultProps = {
    className: '',
  }

  state: State = {
    showFloors: !isMobile,
  };

  showFloors = () => {
    this.setState({ showFloors: !this.state.showFloors });
  };

  render() {
    return (
      <div className={`visio-ui ${this.props.className}`}>
        <div className="zoom-visio">
          <div className="floor-selector">
            {
              this.state.showFloors && this.props.mapviewer.getFloors().reverse().map(floor => (
                <RippleButton
                  key={floor.name}
                  className={this.props.mapviewer.getCurrentFloor() && this.props.mapviewer.getCurrentFloor().index === floor.index ? 'selected' : ''}
                  onClick={() =>
                    this.props.mapviewer.updateFloor(floor).then(() => this.forceUpdate())
                  }
                >
                  {floor.name}
                </RippleButton>))
            }
            <RippleButton onClick={this.showFloors}>
              {I18n.t('mallMap.LEVEL')}
            </RippleButton>
          </div>
          <div className="zoom-button-container">
            <RippleButton
              onClick={this.props.mapviewer.zoomIn}
            >
              <i className="fal fa-plus" />
            </RippleButton>
            <RippleButton
              onClick={this.props.mapviewer.zoomOut}
            >
              <i className="fal fa-minus" />
            </RippleButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(VisioGlobeUI);
